import Need from "../Need";

export const NeedCommonSpecificationView = new Need('common.specification.view');
